
import makerjs from "makerjs";
function A25(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,W1 = Param[1].param, W2 = Param[2].param,

      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       w1 = W1 * 1 * myZoom,
       w2 = W2 * 1 * myZoom,
       w = W * 1 * myZoom,
       p=(w1*1+w2*1+w*1)/2*1,
       s=Math.sqrt((p*(p-w2)*(p-w1)*(p-w))),
       h= 2/w*s*1,
       wx=Math.sqrt(((w2*w2)-(h*h)))*1,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0 = 0, x1 = wx, x2 = w,  y0 = 0, y1 = h, y2 =0,glassH = h, glassW = w;

    if (w1 !== 0) {
    var TxtW1 = W1;
} if (w2 !== 0) {
  var TxtW2 = W2;
}
   if (w !== 0) {
       var TxtW = W;
   }
console.log("w,w1,w2,wx,h,p,s",w,w1,w2,wx,h,p,s);

   var drawAbnormalShapeA25 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "RightLine": new makerjs.paths.Line([x1, y1], [x2, y2]),
        "BottomLine": new makerjs.paths.Line([x2, y2], [x0, y0]),
       }
   };
   var drawAbnormalShapeA25MarkW1 = {
       paths: {
        "UpLine": new makerjs.paths.Line([x1 + markShift, y1], [x2+ markShift, y2 ]),
        "UpShortLfline": new makerjs.paths.Line([x1, y1], [x1+ 2 * markShift, y1 ]),
        "UpShortRTline": new makerjs.paths.Line([x2, y2], [x2+ 2 * markShift, y2 ]),
       }
   };
   var drawAbnormalShapeA25MarkW2 = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x1- markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x1- 2*markShift, y1], [x1, y1]),
        "RightShortDnline": new makerjs.paths.Line([x0- 2*markShift, y0], [x0, y0]),
       }
   };
   var drawAbnormalShapeA25MarkW = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x2, y2 - markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 - 2 * markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeA25MarkW, TxtW, [x0, y0 - 2 * markShift], [x2, y2 - 2 * markShift]);//长度文字  
   makerjs.model.addCaption(drawAbnormalShapeA25MarkW1, TxtW1, [x1 + 2*markShift, y1], [x2+ 2*markShift, y2 ]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeA25MarkW2, TxtW2, [x0- 2*markShift, y0], [x1- 2*markShift, y1]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeA25: drawAbnormalShapeA25,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA25: drawAbnormalShapeA25,
        drawAbnormalShapeA25MarkW1: drawAbnormalShapeA25MarkW1,
        drawAbnormalShapeA25MarkW2: drawAbnormalShapeA25MarkW2,
        drawAbnormalShapeA25MarkW:drawAbnormalShapeA25MarkW
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A25;